import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCursorList: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="cursor-list, cursor, list"><path d="M11.875 16.375L15.744 12.506L3.75 8.25L8.00595 20.244L11.875 16.375ZM11.875 16.375L16.75 21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M20.25 3.75H10.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M20.25 7.75H15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconCursorList;
